/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
//import {Link} from 'react-router-dom'
//import {useAuth} from '../../../../app/modules/auth'
import { useAuth } from '../../../../app/modules/auth/core/Auth';
import {Buffer} from 'buffer'
//import {Languages} from './Languages'
//import {toAbsoluteUrl} from '../../../helpers'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const user = Array.isArray(currentUser) && currentUser.length > 0 ? currentUser[0] : currentUser;
  if (user.Foto_profilo?.data) {
    const arrayBuffer = user.Foto_profilo.data
    const base64String = Buffer.from(arrayBuffer).toString('base64')
    // Metti la data URL direttamente in singleUser.Foto_profilo
    // Se sai che è PNG, metti "image/png"; se è JPEG, "image/jpeg", ecc.
    user.Foto_profilo = `data:image/png;base64,${base64String}`
  }
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={user.Foto_profilo} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {user?.Nome} {user?.Cognome}
              <span className='badge badge-light-primary fw-bolder fs-8 px-2 py-1 ms-2'>{user?.Ruolo}</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {user?.Email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {/*<div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>Attività in corso</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>*/}

      <div className='separator my-2'></div>

      {/*<Languages />*/}

      {/*<div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Impostazioni account
        </Link>
      </div>*/}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Esci
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
